import { render } from "./component.vue?vue&type=template&id=5cafac00"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"

import "./component.vue?vue&type=style&index=0&id=5cafac00&lang=scss"

import exportComponent from "/home/runner/work/my.fastfinance.app/my.fastfinance.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__